/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ActivityTimeline.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays the chronological activity timeline for
 * the work execution.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display execution history
 * ✓ Display activity type
 * ✓ Display user
 * ✓ Display timestamp
 *
 ******************************************************************************/

import React from "react";

export default function ActivityTimeline({

    timeline = [],

}) {

    return (

        <div className="card shadow-sm border-0 mb-4">

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div className="card-header bg-white">

                <h5 className="mb-0">

                    Activity Timeline

                </h5>

            </div>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            <div className="card-body">

                {

                    timeline.length === 0 && (

                        <div className="text-center text-muted py-4">

                            No activities available.

                        </div>

                    )

                }

                {

                    timeline.map((activity, index) => (

                        <div

                            key={activity.id}

                            className={

                                index !== timeline.length - 1

                                    ? "border-start border-3 ps-4 pb-4 ms-2"

                                    : "ps-4 ms-2"

                            }

                        >

                            <div className="fw-bold">

                                {activity.activity}

                            </div>

                            <div className="text-muted small">

                                {activity.user}

                            </div>

                            <div className="text-muted small">

                                {activity.datetime}

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}